import React, { useState, useEffect } from "react";
import { parseISO, format } from "date-fns";
import { FaCircle } from "react-icons/fa";
import RequestService from "../services/RequestService";
import { isSLAPassed, isSLANear, isSLATwoHour } from "../utils/SLACalcs";
import { RiTimerLine } from "react-icons/ri";
import StatusRequests from "../enums/StatusRequests";
import { FaInfoCircle } from "react-icons/fa"
import { FaEye } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import RequestDetailsModal from "./modals/RequestDetailsModal";
import { startPolling } from "../utils/polling";
import { statusAlertaPortaria } from "../utils/alertaPortaria";

function Monitor2( setLoggedIn ) {
  const [currentDate, setCurrentDate] = useState("");
  const [currentDayOfWeek, setCurrentDayOfWeek] = useState("");

  const [requests, setRequests] = useState([]);
  const [requestsNovos, setRequestsNovos] = useState([]);
  const [requestsBackoffice, setRequestsBackoffice] = useState([]);
  const [requestsDeposito, setRequestsDeposito] = useState([]);
  const [requestsRepasse, setRequestsRepasse] = useState([]);
  const [requestsRota, setRequestsRota] = useState([]);
  const [isSummaryCollapsed, setIsSummaryCollapsed] = useState(true);

  const [quantidadeNovo, setQuantidadeNovo] = useState();
  const [quantidadeBackoffice, setQuantidadeBackoffice] = useState();
  const [quantidadeDeposito, setQuantidadeDeposito] = useState();
  const [quantidadeRepassaParaEntrega, setQuantidadeRepassaParaEntrega] = useState();
  const [quantidadeRotaDeEntrega, setQuantidadeRotaDeEntrega] = useState();
  const [quantidadeEntregue, setQuantidadeEntregue] = useState();
  // const [quantidadeFinalizado, setQuantidadeFinalizado] = useState();
  const [quantidadeGestao, setQuantidadeGestao] = useState();

  const [requestDetailsModal, setRequestDetailsModal] = useState(false);
  const [requestOnDetailsModal, setRequestOnDetailsModal] = useState();

  const navigate = useNavigate();

  // Função genérica para lidar com erros de autenticação
  const handleUnauthorizedError = (error) => {
    if (error.response?.status === 401) {
      // setLoggedIn(false);
      localStorage.removeItem("token");
      navigate("/login");
    }
  };


  // ================= USEEFFECT ÚNICO PARA AS LISTAS DO MONITOR =================
  // Antes eram 5 useEffect, um por status, cada um com seu próprio ciclo de
  // atualização. Agora é uma chamada só, que devolve todas as listas.
  useEffect(() => {
    const fetchRequests = async () => {
      try {
        const listas = await RequestService.getMonitorLists();
        if (!listas) return;

        setRequestsNovos(listas["NOVO"]?.requests || []);
        setRequestsBackoffice(listas["BACKOFFICE"]?.requests || []);
        setRequestsDeposito(listas["DEPOSITO"]?.requests || []);
        setRequestsRepasse(listas["REPASSE PARA ENTREGA"]?.requests || []);
        setRequestsRota(listas["ROTA DE ENTREGA"]?.requests || []);
      } catch (error) {
        handleUnauthorizedError(error);
      }
    };

    fetchRequests();
    return startPolling(fetchRequests);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setLoggedIn, navigate]);

  // ================= USEEFFECT PARA UNIFICAR REQUESTS =================
  useEffect(() => {
    const allRequests = [
      ...(Array.isArray(requestsNovos) ? requestsNovos : []),
      ...(Array.isArray(requestsBackoffice) ? requestsBackoffice : []),
      ...(Array.isArray(requestsDeposito) ? requestsDeposito : []),
      ...(Array.isArray(requestsRepasse) ? requestsRepasse : []),
      ...(Array.isArray(requestsRota) ? requestsRota : []),
    ];

    const sortedRequests = allRequests.sort((a, b) => {
      const dateA = new Date(a.slaDate);
      const dateB = new Date(b.slaDate);
      return dateA - dateB;
    });

    setRequests(sortedRequests);
  }, [
    requestsNovos,
    requestsBackoffice,
    requestsDeposito,
    requestsRepasse,
    requestsRota,
  ]);

  // ================= USEEFFECT PARA ATUALIZAR COLUNA RESUMO =================
  useEffect(() => {

    const updateDate = () => {
      const today = new Date();
      const dd = String(today.getDate()).padStart(2, "0");
      const mm = String(today.getMonth() + 1).padStart(2, "0"); // Mês é indexado a partir de 0
      const yyyy = today.getFullYear();

      const formattedDate = `${dd}/${mm}/${yyyy}`;
      setCurrentDate(formattedDate);

      const dayOfWeek = today.toLocaleDateString("pt-BR", { weekday: "long" });
      setCurrentDayOfWeek(dayOfWeek);
    };
    updateDate(); // Chama a função inicialmente para definir a data atual

    const fetchSummary = async () => {
      try {
        const requestTodas = await RequestService.calculateSummary();
        if (requestTodas) {
          setQuantidadeNovo(requestTodas?.totalNovos);
          setQuantidadeBackoffice(requestTodas?.totalBackoffice);
          setQuantidadeGestao(requestTodas?.totalGestao);
          setQuantidadeDeposito(requestTodas?.totalDeposito);
          setQuantidadeRepassaParaEntrega(requestTodas?.totalRepasseEntrega);
          setQuantidadeRotaDeEntrega(requestTodas?.totalRotaEntrega);
          setQuantidadeEntregue(requestTodas?.totalEntregue);
        }
      } catch (error) {
        handleUnauthorizedError(error);
      }
    };

    fetchSummary();
    return startPolling(fetchSummary, 60000);
  }, [setLoggedIn, navigate]);


  const handleRequestDetailsModal = async (ticketId) => {
    setRequestDetailsModal(true)
    setRequestOnDetailsModal(ticketId)
  };


  return (
    <div className="flex w-full h-full justify-center items-center gap-3 py-4 px-3 bg-gray-200">

      <div className="flex 3xl:flex-col w-full min-h-full rounded-xl gap-2">

        {/* LEFT CONTAINER */}
        <div className="flex flex-col min-w-fit min-h-full gap-2 rounded-xl p-4 bg-white divide-y transition-all duration-300"
          onMouseOver={() => setIsSummaryCollapsed(false)}
          onMouseOut={() => setIsSummaryCollapsed(true)}
        >
          {!isSummaryCollapsed ? (
            <div className="flex flex-col gap-1 transition-all duration-300">
              <div className="w-full ps-2 text-2xl text-gray-800 font-bold">
                Resumo
              </div>
              <div className="w-fit px-2 text-sm font-extralight text-white flex justify-center items-center bg-gray-800 rounded-full">
                {currentDate}, {currentDayOfWeek}
              </div>
            </div>
          ) : (
            <FaInfoCircle size={25} className="text-gray-800 transition-opacity duration-300 ease-in-out" />
          )}

          <div className="flex flex-col gap-2 py-4 transition-all duration-300">
            <div className="flex gap-3 items-center">
              <div className="w-6 h-6 flex bg-red-400 justify-center items-center rounded-full">
                <div className="flex justify-center items-center w-4 h-4 text-black font-semibold">
                  {quantidadeGestao}
                </div>
              </div>
              {!isSummaryCollapsed && <div className="text-sm transition-all duration-300">Aguardando Gestão</div>}
            </div>

            <div className="flex gap-3 items-center">
              <div className="w-6 h-6 flex bg-gray-300 justify-center items-center rounded-full">
                <div className="flex justify-center items-center w-4 h-4 text-black font-semibold">
                  {quantidadeNovo}
                </div>
              </div>
              {!isSummaryCollapsed && <div className="text-sm transition-all duration-300">Novos</div>}
            </div>

            <div className="flex gap-3 items-center">
              <div className="w-6 h-6 flex bg-yellow-300 justify-center items-center rounded-full">
                <div className="flex justify-center items-center w-4 h-4 text-black font-semibold">
                  {quantidadeBackoffice}
                </div>
              </div>
              {!isSummaryCollapsed && <div className="text-sm transition-all duration-300">Backoffice</div>}
            </div>

            <div className="flex gap-3 items-center">
              <div className="w-6 h-6 flex bg-purple-300 justify-center items-center rounded-full">
                <div className="flex justify-center items-center w-4 h-4 text-black font-semibold">
                  {quantidadeDeposito}
                </div>
              </div>
              {!isSummaryCollapsed && <div className="text-sm transition-all duration-300">Depósito</div>}
            </div>

            <div className="flex gap-3 items-center">
              <div className="w-6 h-6 flex bg-sky-200 justify-center items-center rounded-full">
                <div className="flex justify-center items-center w-4 h-4 text-black font-semibold">
                  {quantidadeRepassaParaEntrega}
                </div>
              </div>
              {!isSummaryCollapsed && <div className="text-sm transition-all duration-300">Repasse para Entrega</div>}
            </div>

            <div className="flex gap-3 items-center">
              <div className="w-6 h-6 flex bg-sky-400 justify-center items-center rounded-full">
                <div className="flex justify-center items-center w-4 h-4 text-black font-semibold">
                  {quantidadeRotaDeEntrega}
                </div>
              </div>
              {!isSummaryCollapsed && <div className="text-sm transition-all duration-300">Em Rota de Entrega</div>}
            </div>

            <div className="flex gap-3 items-center">
              <div className="w-6 h-6 flex bg-sky-700 justify-center items-center rounded-full">
                <div className="flex justify-center items-center w-4 h-4 text-black font-semibold">
                  {quantidadeEntregue}
                </div>
              </div>
              {!isSummaryCollapsed && <div className="text-sm transition-all duration-300">Entregues</div>}
            </div>

            {/* <div className="flex gap-3 items-center">
                    <div className="w-6 h-6 flex bg-green-500 justify-center items-center rounded-full">
                      <div className="flex justify-center items-center w-4 h-4 text-black font-semibold">
                        {quantidadeFinalizado}
                      </div>
                    </div>
                    {!isSummaryCollapsed && <div className="text-sm transition-all duration-300">Finalizados</div>}
                  </div> */}

          </div>
        </div>

        {/* RIGHT CONTAINER */}
        <div className="flex flex-col w-full min-h-full rounded-xl gap-8 bg-white py-4">
          <div className="flex flex-col w-full rounded-xl py-2 px-4">

            <div className="flex items-center gap-2 w-full text-lg font-semibold ps-2 mt-2">
              <FaEye size={23} className=" animate-pulse" />Monitor de Chamados
            </div>

            <div className="overflow-x-auto mt-2 rounded-lg">
              <table className="min-w-full rounded-lg text-[9px]">
                <thead className="bg-gray-400">
                  <tr>
                    <th className="py-2 px-4 border-b">Status</th>
                    <th className="py-2 px-4 border-b">Nº da Solicitação</th>
                    <th className="py-2 px-4 border-b">Agente</th>
                    <th className="py-2 px-4 border-b">Criado em</th>
                    <th className="py-2 px-4 border-b">Cod Sap</th>
                    <th className="py-2 px-4 border-b">DRS Origem</th>
                    <th className="py-2 px-4 border-b">DRS Atender</th>
                    <th className="py-2 px-4 border-b">Qtd Solicitada</th>
                    <th className="py-2 px-4 border-b">Atendimento</th>
                    <th className="py-2 px-4 border-b">Técnico</th>
                    <th className="py-2 px-4 border-b">Tipo Boleto</th>
                    <th className="py-2 px-4 border-b">Cidade</th>
                    <th className="py-2 px-4 border-b">ID Boleto</th>
                    <th className="py-2 px-4 border-b whitespace-nowrap">Portaria</th>
                    <th className="py-2 px-4 border-b">
                      <div className="flex justify-center items-center">
                        Data SLA ou Programado
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {requests.map((request, index) => (
                    <tr
                      key={`request-${index}`}
                      className={`border-t hover:bg-gray-100 ${isSLAPassed(request.slaDate)
                          ? "bg-red-100"
                          : isSLANear(request.slaDate)
                            ? "bg-yellow-100"
                            : isSLATwoHour(request.slaDate)
                              ? "bg-yellow-200"
                              : ""
                        }`}
                    >
                      <td className="py-1 px-4">
                        <div className="flex items-center gap-2">
                          <FaCircle
                            color={StatusRequests[request?.status]?.cor}
                            size={15}
                          />
                          {request.status}
                        </div>
                      </td>
                      <td className="py-1 px-4 cursor-pointer underline font-bold" onClick={()=>handleRequestDetailsModal(request._id)}>{request.idRequest}</td>
                      <td className="py-1 px-4">{request.agent?.name || ""}</td>
                      <td className="py-1 px-4">
                        {format(parseISO(request.createdAt), "dd/MM/yy HH:mm")}
                      </td>
                      <td className="py-1 px-4">{request.codSap}</td>
                      <td className="py-1 px-4">{request.drsOriginal?.sigla || ""}</td>
                      <td className="py-1 px-4">{request.drsAtender?.sigla || ""}</td>
                      <td className="py-1 px-4">{request.quantidadeSolicitada}</td>
                      <td className="py-1 px-4">
                        <div className="flex justify-center items-center gap-2">
                          {["bbn-alta", "bbn-media"].includes(request.tipoAtendimento) ? (
                            <span className="text-black font-bold rounded-lg px-1 bg-yellow-300">
                              {request.tipoAtendimento.toUpperCase()}
                            </span>
                          ) : (
                            request.tipoAtendimento.toUpperCase()
                          )}
                        </div>
                      </td>
                      <td className="py-1 px-4">{request.tecnico || request.user.name}</td>
                      <td className="py-1 px-4">{request.tipoBoleto.toUpperCase()}</td>
                      <td className="py-1 px-4">
                        {request.cidadeEntrega === "SÃO PAULO"
                          ? "SP-" + request.gmo.identificador
                          : request.cidadeEntrega}
                      </td>
                      <td className="py-1 px-4">{request.idBoleto}</td>
                      {/* Portaria avisada da saída? Só faz sentido depois que o
                          material saiu do depósito — antes disso não há o que
                          notificar, e pintar a coluna inteira viraria ruído. */}
                      <td className="py-1 px-4">
                        {request.status === "ROTA DE ENTREGA"
                          ? (() => {
                            const alerta = statusAlertaPortaria(request);

                            if (alerta.estado === "notificada") {
                              return (
                                <div
                                  className="flex justify-center items-center gap-1 text-green-700 whitespace-nowrap cursor-help"
                                  title={alerta.detalhe}
                                >
                                  <FaCircle size={7} /> {alerta.rotulo}
                                </div>
                              );
                            }

                            // Sem registro ≠ falhou: o acumulado anterior ao
                            // controle fica neutro, para o vermelho continuar
                            // significando algo.
                            if (alerta.estado === "sem-registro") {
                              return (
                                <div
                                  className="flex justify-center text-gray-400 whitespace-nowrap cursor-help"
                                  title={alerta.detalhe}
                                >
                                  sem registro
                                </div>
                              );
                            }

                            return (
                              <div
                                className="flex justify-center items-center text-white font-bold bg-red-600 rounded-full px-2 py-[1px] whitespace-nowrap animate-pulse cursor-help"
                                title={alerta.detalhe}
                              >
                                SEM ALERTA
                              </div>
                            );
                          })()
                          : <div className="flex justify-center text-gray-400">—</div>}
                      </td>
                      <td
                        className={`py-1 px-4 ${request?.slaDate && isSLAPassed(request.slaDate)
                            ? "text-red-500 font-bold"
                            : request?.slaDate && isSLANear(request.slaDate)
                              ? "text-yellow-600 font-bold"
                              : request?.slaDate && isSLATwoHour(request.slaDate)
                                ? "text-yellow-600 font-bold animate-pulse-fast"
                                : ""
                          }`}
                      >
                        <div className="flex gap-1 items-center font-bold">
                          {request?.slaDate
                            ? format(parseISO(request.slaDate), "dd/MM/yy HH:mm")
                            : "N/A"}
                          {request?.slaDate && isSLATwoHour(request.slaDate) && (
                            <RiTimerLine size={12} />
                          )}
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      {requestOnDetailsModal &&
        <div className="absolute">
          <RequestDetailsModal
            isModalOpen={requestDetailsModal}
            setModalOpen={() => {
              setRequestDetailsModal(!requestDetailsModal);
            }}
            requestId={requestOnDetailsModal}
          // setTicketCb={setTicket}
          ></RequestDetailsModal>
        </div>
      }

    </div>
  );
}

export default Monitor2;
